import Image from 'next/image'
import FastCasual from 'src/assets/svg/fast_casual.svg'

interface IconChipProps {
  title: string
  imgSrc?: string
}

export default function IconChip(props: IconChipProps) {
  const { imgSrc } = props
  return (
    <div
      className="px-2 py-1 rounded-full inline-flex flex-row gap-1"
      style={{ background: '#FBFAF9', border: '1px solid #E6E6E6E6' }}>
      <Image
        src={imgSrc || FastCasual}
        alt="Fast Casual"
        width={17}
        height={17}
      />
      <p
        className="font-medium text-xs text-center"
        style={{ color: '#4A4340' }}>
        {props.title}
      </p>
    </div>
  )
}
